/**
 * API URL configuration.
 * In production (HTTPS), uses relative URLs so nginx handles proxying.
 * In development (localhost), falls back to explicit port.
 */

function resolveUrl(envVar: string | undefined, fallbackPort: number, protocol: 'http' | 'ws' = 'http'): string {
  const isSecureOrigin = window.location.protocol === 'https:';
  // If explicit env var is set and not localhost, use it
  if (envVar && !envVar.includes('localhost')) {
    if (isSecureOrigin && envVar.startsWith('http://')) {
      return '';
    }
    if (isSecureOrigin && envVar.startsWith('ws://')) {
      return envVar.replace(/^ws:\/\//, 'wss://').replace(/\/+$/, '');
    }
    return envVar.replace(/\/+$/, '').replace(/\/api(\/v1)?$/, '');
  }

  const hostname = window.location.hostname;
  const isProduction = isSecureOrigin || (hostname !== 'localhost' && hostname !== '127.0.0.1');

  // In production: use relative URL (nginx proxies /api/ to gateway)
  if (isProduction && protocol === 'http') {
    return '';
  }

  // WebSocket: match current protocol (wss for HTTPS, ws for HTTP)
  if (protocol === 'ws') {
    if (isProduction) {
      const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      return `${wsProtocol}://${hostname}`;
    }
    return `${protocol}://${hostname}:${fallbackPort}`;
  }

  // Development: use explicit port
  return `${protocol}://${hostname}:${fallbackPort}`;
}

export const API_URL = resolveUrl(process.env.REACT_APP_API_URL, 8080);
export const API_BASE_URL = `${API_URL}/api/v1`;
export const HOTEL_SERVICE_URL = resolveUrl(process.env.REACT_APP_HOTEL_SERVICE_URL, 8082);
export const WS_URL = resolveUrl(process.env.REACT_APP_WS_URL, 8088, 'ws');
